import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./pages/Kontaktformular/theme.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  /**
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
  */
  <App />
);

reportWebVitals();
